module.exports = __webpack_public_path__ + "static/Ice@2x.ffc5f7a8.png";